import React from 'react'
import { Link } from 'react-router-dom'
import { IconArrowUpRight, IconBriefcase } from '@tabler/icons-react'

import './styles/prospects.css'

function Prospects() {

    const vacantJobs = [
        {
            nombre: "Ingeniero Civil",
            descripcion: "Supervisa proyectos de construcción, asegurando estándares de seguridad."
        },
        {
            nombre: "Diseñador Gráfico",
            descripcion: "Crea diseños visuales para proyectos y campañas publicitarias."
        },
        {
            nombre: "Obrero",
            descripcion: "Realiza tareas de construcción y mantenimiento, garantizando la seguridad en el trabajo."
        },
        {
            nombre: "Cajero",
            descripcion: "Atiende clientes y gestiona transacciones de forma eficiente, manteniendo la precisión en los registros."
        }
    ];
    

    return (

        <section className='--prospects'>

            <div className='--tit'>
                <h2>
                    <span>Ver trabajos vacantes </span>
                    <span>en tu campo</span>
                </h2>
                <Link to={'/'} className='--a-seemore'>
                    <span>Ver más</span>
                    <IconArrowUpRight/>
                </Link>
            </div>

            <div className='--lst-cards'>

                {vacantJobs.map((job, i) => (

                    <div className='--card' key={i}>

                        <div className='--card-head'>
                            <div className='--ico'>
                                <IconBriefcase/>
                            </div>
                        </div>

                        <div className='--card-body'>
                            <h3>{job.nombre}</h3>
                            <p>{job.descripcion}</p>
                        </div>

                    </div>

                ))}

            </div>

            <Link to={'/'} className='--a-seemore-bg'>
                <span>Ver más</span>
                <IconArrowUpRight/>
            </Link>

        </section>

    )

}

export default Prospects